<template>
  <div class="people-dropdown">
    <div v-if="countValidation.text.length > 0"
      class="people-dropdown__message"
      :class="{ [`people-dropdown__message--${countValidation.type}`]: true }" >
      {{ countValidation.text }}
    </div>
    <div class="people-dropdown__wrapper">
      <div class="people-dropdown__close">
        <span class="custom-icon--cross calendar-header__icon" @click="$emit('close')" />
      </div>
      <PeopleEdit class="people-dropdown__body" ref="people"
        :value="value" :adultsLabel="adultsLabel" :childrenLabel="childrenLabel"
        @peopleCountValidation="togglePeopleCountValidation"
        @dateInputToggled="dateInputToggled" />
    
      <div class="people-dropdown__clear" @click="reset">
        <Icon icon="cross" />
        <span>Wyczyść wszystko</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import AutoCloseMixin from '@/components/AutoCloseMixin'
import Icon from '@/components/Icon'
import PeopleEdit from '@/components/search/fields/PeopleEdit.vue'

@Component({
  mixins: [
    AutoCloseMixin,
  ],
  components: {
    PeopleEdit,
    Icon,
  },
  props: {
    value: {
      type: Object, // See People.value prop for model definition
      required: true,
    },
  },
})
export default class PeopleDropdown extends Vue {
  showBirthdayWarning = false
  adultsLabel = 'Dorośli'
  childrenLabel = 'Dzieci'
  countValidation = { text: '', type: '' }

  mounted () {
    this.$emit('adjustVisibility', this.$el)
  }

  reset () {
    this.$refs.people.clear()
  }

  close () {
    this.$emit('close')
  }

  togglePeopleCountValidation (message) {
    this.countValidation = message
    this.$emit('adjustVisibility', this.$el)
  }

  dateInputToggled (toggled) {
    if (toggled) this.$emit('adjustVisibility', { target: this.$el, margin: 210 })
  }
}
</script>

<style lang="scss">
.people-dropdown {
  background-color: #fff;
  position: absolute;
  width: 100%;
  max-width: 170px;
  box-shadow: 0 6px 12px rgba(0,0,0,.175);
  z-index: 1;
  margin-top: 4px;

  &__wrapper {
    position: relative;
  }

  &__close {
    position: absolute;
    right: 0;
    padding: 0 7px;
    top: -3px;
    color: #005ca9;
    cursor: pointer;
    z-index: 1;
  }

  &__clear {
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-size: 12px;
    text-align: center;
    padding: 18px 0;

    &:hover {
      color: #009FEA;
      cursor: pointer;
    }

    .figure {
      font-size: 8px;
      margin-right: 5px;
    }

    span:last-child {
      line-height: 8px;
    }
  }

  &__message {
    font-size: 12px;
    text-transform: uppercase;
    padding: 10px 20px 8px 20px;

    @include media(tablet) {
      padding: 6px 10px 6px 10px;
    }
  }

  &__message--error {
    color: white;
    background-color: #E71F6C;
  }

  .people-edit {
    &__number-input {
      width: auto;
    }

    &__child-birthday {
      max-width: none;
      margin: 0;
    }
  }
  
  .selection-box__icon {
    top: 1px;
    height: calc(100% - 3px);
    z-index: 1;
    background: #fff;
    padding-left: 4px;
    pointer-events: none;

    &::before {
      display: inline-block;
      margin-top: 11px;
    }
  }

  hr {
    margin: 10px 0;
  }

  /*
   * Set the initial position of these two elements to not to break
   * default component styles in other reused places - because of grid-areas
   */
  .date-input,
  .date-input__value {
    @include media(tablet) {
      width: auto;
      position: initial;
    }
  }

  .date-input__dropdown {
    @include media(tablet) {
      width: 280px;
      margin-left: -13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/PeopleDropdown.vue